module.exports = __webpack_public_path__ + "static/media/Portrait-10211.b4b485d9.jpg";